export default {
  SET_LIST_SERVERS(state, { data, total, count }) {
    state.servers.data = data;
    state.servers.total = total;
    state.servers.count = count;
  },
  SET_LIST_SERVERS_APPEND(state, servers) {
    state.servers.data = [...state.servers.data, ...servers.data];
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
};
